import { Button, Space, Tooltip, Typography } from 'antd';
import { useMemo } from 'react';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import {
  PF,
  CLIENTS_FILTER_SEGMENTS,
} from '@pages/Clients/NewClientsList/data/constants';
import { getSelectedSegmentValue } from '@pages/Clients/NewClientsList/utils/segments';

const { Title } = Typography;

export const Segments = () => {
  const { filters: currentFilters, onChangeFilters } =
    useNewClientsListContext();

  const selectedSegmentValue = useMemo(
    () => getSelectedSegmentValue(currentFilters, CLIENTS_FILTER_SEGMENTS),
    [currentFilters]
  );

  return (
    <div className={`${PF}__row`}>
      <Title level={5} className={`${PF}__row__title`}>
        Сегменты:
      </Title>

      <Space wrap className={`${PF}__row__segments`}>
        {CLIENTS_FILTER_SEGMENTS.map(
          ({ label, value, tooltip, buttonType, filters: segmentFilters }) => {
            const isSelected = selectedSegmentValue === value;

            return (
              <Tooltip
                key={value}
                title={tooltip}
                placement="top"
                color="white"
                classNames={{
                  body: `${PF}__row__tooltip`,
                }}
              >
                <Button
                  type={isSelected ? 'primary' : buttonType ?? 'default'}
                  aria-pressed={isSelected}
                  className={`${PF}__row__segment-button${
                    isSelected ? ` ${PF}__row__segment-button--selected` : ''
                  }`}
                  onClick={() => onChangeFilters(segmentFilters)}
                >
                  {label}
                </Button>
              </Tooltip>
            );
          }
        )}
      </Space>
    </div>
  );
};
